import { render, staticRenderFns } from "./CandidateResultsDetails.vue?vue&type=template&id=4987ac1a&"
import script from "./CandidateResultsDetails.vue?vue&type=script&lang=js&"
export * from "./CandidateResultsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports